import PonchoIcon from "./PonchoIcon";

export default function AireIcon({ ...props }) {
  return <PonchoIcon name="aire" {...props} />;
}
